// src/components/api/axios.js
import axios from 'axios';

// Central API Base URL - allows overriding with REACT_APP_API_URL if needed
export const API_BASE_URL = (
  process.env.REACT_APP_API_URL || 'https://blog.dietchapter.hosting.acm.org'
).replace(/\/+$/, '');

const instance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

export default instance;

